import { render, staticRenderFns } from "./FormationAreaRow.vue?vue&type=template&id=4582e13a"
import script from "./FormationAreaRow.vue?vue&type=script&lang=js"
export * from "./FormationAreaRow.vue?vue&type=script&lang=js"
import style0 from "./FormationAreaRow.vue?vue&type=style&index=0&id=4582e13a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports